var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/web.immediate.js
// module id = 44uO
// module chunks = 1